import React from 'react'

const Clock = () => {
  return (
    <div>
       <p className="clock" style={{color:'whitesmoke', fontSize: '2rem', letterSpacing: '11px'}}>Time<span className="clockColon">:</span>{new Date().toLocaleTimeString()} </p>
      {/* <Link to='/about'>About</Link> */}
      {/* {setInterval(Clock, 1000)} */}
    </div>
    
  )
  // function tick() {
  //   return (<Clock date={new Date()} />);
  // }
  // setInterval(Clock, 1000);
}



export default Clock